import { apiGet } from "api/callApi";
import { DropdownWithSearch } from "InnoUI/innoinput";
import { useEffect, useState } from "react";

const DisplayTemplateDropdown = (props) => {
  const {
    onChange,
    templateOption,
    name,
    defaultValue,
    disabledDropdown,
    width = "90%",
  } = props;

  const [template, setTemplate] = useState(templateOption || []);

  const getAllTemplate = async () => {
    if (!templateOption || templateOption.length === 0) {
      try {
        const response = await apiGet("/v1/templates", false);
        const projectOptions = response.data.map((template) => ({
          id: template.id,
          label: template.name,
        }));
        setTemplate(projectOptions);
      } catch (error) {
        console.error("Error fetching projects", error);
      }
    }
  };

  useEffect(() => {
    getAllTemplate();
  }, [templateOption]);

  const handleDropdownChange = (value) => {
    const selectedOption = template.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.label : "";
    // Pass both value and label to the onChange handler
    onChange(name, value, selectedLabel);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      placeholder="Select Folder Template"
      options={template}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={true}
      width={width}
      dropdowType={"DisplayTemplateDropdown"}
      disabledDropdown={disabledDropdown}
    />
  );
};

export default DisplayTemplateDropdown;
